// /app/connect/hydros opens the app straight on Account > Connect HYDROS
// with the key field ready, so a guide, a newsletter or an email can send
// a keeper to the exact place (owner, 2026-09-30). A keeper who is not
// signed in goes through sign-in and comes back here.

// /app/connect/ring is Ring's Account Link URL (set in Ring's portal):
// Ring sends the keeper there with ?nonce=&time= to finish a link.
const CONNECT_PATHS = {
  hydros: /^\/app\/connect\/hydros\/?$/i,
  ring: /^\/app\/connect\/ring\/?$/i,
};

export function openTargetFrom(pathname) {
  for (const [target, re] of Object.entries(CONNECT_PATHS)) {
    if (re.test(pathname || '')) return target;
  }
  return null;
}

// Where a sign-in link should return to: an explicit ?next= wins, else a
// connect page itself, so a keeper who signs in by email link still
// lands on it.
export function signInReturnPath(pathname, search) {
  const next = new URLSearchParams(search || '').get('next');
  if (next) return next;
  // The query goes along: Ring's link carries its nonce and time there.
  return openTargetFrom(pathname) ? pathname + (search || '') : null;
}

// In-app: any screen can open the Account sheet on a section without a
// reload.
export const OPEN_ACCOUNT_EVENT = 'ts:open-account';

// In-app: open Tank settings on one section (detail: 'equipment').
export const OPEN_SETTINGS_EVENT = 'ts:open-settings';

// In-app: open Add a tank from anywhere. detail.returnTo reopens the Account
// sheet on that section afterwards ('hydros-link': Connect HYDROS, to link
// the new tank; feedback #69).
export const OPEN_ADD_TANK_EVENT = 'ts:open-add-tank';

// In-app: a HYDROS key, link or unlink changed from Account, so Home's
// "not linked to a tank" row asks again.
export const HYDROS_CHANGED_EVENT = 'ts:hydros-changed';

// The sign-in screen opened from a tank-share invite (next is the accept
// link): it says so, and which address to use (owner, 2026-10-28).
export function isInviteReturn(search) {
  const next = new URLSearchParams(search || '').get('next');
  return typeof next === 'string' && next.startsWith('/api/shares/accept?');
}
